import { ORDER_STATUS, ORDER_STATUS_LABEL } from 'constants/all';

import type { OrderListTabId } from 'modules/orders/listPage/types';

import type { OrderListTabConstraint } from '../types';

export const ORDER_LIST_TABS_STATIC_DATA = {
  [ORDER_STATUS.ALL]: {
    tabId: ORDER_STATUS.ALL,
    tabCountKey: 'all',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.ALL],
    path: '/all',
  },
  [ORDER_STATUS.PENDING]: {
    tabId: ORDER_STATUS.PENDING,
    tabCountKey: 'pending',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.PENDING],
    path: '/pending',
  },
  [ORDER_STATUS.CONFIRMED]: {
    tabId: ORDER_STATUS.CONFIRMED,
    tabCountKey: 'confirmed',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.CONFIRMED],
    path: '/confirmed',
  },
  [ORDER_STATUS.IN_PROCESS]: {
    tabId: ORDER_STATUS.IN_PROCESS,
    tabCountKey: 'inProcess',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.IN_PROCESS],
    path: '/in_process',
  },
  [ORDER_STATUS.ON_HOLD]: {
    tabId: ORDER_STATUS.ON_HOLD,
    tabCountKey: 'onHold',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.ON_HOLD],
    path: '/on_hold',
  },
  [ORDER_STATUS.CANCELLED]: {
    tabId: ORDER_STATUS.CANCELLED,
    tabCountKey: 'cancelled',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.CANCELLED],
    path: '/cancelled',
  },
  [ORDER_STATUS.COMPLETED]: {
    tabId: ORDER_STATUS.COMPLETED,
    tabCountKey: 'completed',
    title: ORDER_STATUS_LABEL[ORDER_STATUS.COMPLETED],
    path: '/completed',
  },
} as const satisfies Record<
  OrderListTabId,
  Omit<OrderListTabConstraint, 'columns'>
>;
